import { HttpError } from '@hatsy/hatsy';
import { resolve } from 'node:path';
import send from 'send';
import { redirectToDirectory } from './redirect-to-directory.impl.js';
/**
 * Creates a request handler that serves static content from the given `root` directory.
 *
 * @param root - Root directory to serve files from.
 * @param config - Static contents service configuration.
 *
 * @returns New HTTP route processing handler.
 */
export function serveStatic(root, config = {}) {
    const { redirect = true, maxAge = 0 } = config;
    const opts = { ...config, maxAge, root: resolve(root) };
    return async (context) => {
        const { request, response, route, fullRoute } = context;
        if (request.method !== 'GET' && request.method !== 'HEAD') {
            return;
        }
        await new Promise((resolve, reject) => {
            // Ensure the path does not start with `/` unless a directory requested.
            const path = route.path.length ? `/${route.toPathString()}` : fullRoute.dir ? '/' : '';
            const stream = send(request, path, opts);
            stream.on('directory', () => {
                if (!redirect) {
                    resolve();
                }
                else {
                    resolve(redirectToDirectory(context));
                }
            });
            stream.on('error', (cause) => {
                reject(new HttpError(cause.statusCode, { message: cause.message, cause }));
            });
            stream.on('end', resolve);
            stream.pipe(response);
        });
    };
}
//# sourceMappingURL=serve-static.handler.js.map